import OneAccountIcon from '@/components/icons/OneAccountIcon';
import { TransactionRequestSelectionItem } from '@/types/transactionRequests';
import { AccountBalance } from '@mui/icons-material';
import { Typography, Box } from '@mui/material';

type SVAccountLabelProps = {
  label: string;
  account?: TransactionRequestSelectionItem;
};

export default function SVAccountLabel({
  label,
  account,
}: SVAccountLabelProps) {
  return (
    <>
      <Typography variant="body1" fontWeight="bold" color="primary">
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {account?.isInternalAccount ? (
          <OneAccountIcon color="primary" />
        ) : (
          <>
            {account?.iconUrl ? (
              <img
                style={{
                  height: '35px',
                  width: '35px',
                  marginRight: '8px',
                }}
                src={account.iconUrl}
              />
            ) : (
              <AccountBalance />
            )}
          </>
        )}
        <Typography variant="body1">{account?.label}</Typography>
      </Box>
    </>
  );
}
